import { PlatformApplication, Response } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';

const v1Path = '/v1/messengers';

export interface PlatformApplicationsResponseData {
  platformApplications: PlatformApplication[];
}

export function getPlatformApplications(
  messengerId: string,
): Promise<Response<PlatformApplicationsResponseData>> {
  return ajaxSend({
    path: `${v1Path}/${messengerId}/platform_application`,
  });
}
